<template>
  <span>
    <v-autocomplete dense v-bind:value="value" :disabled="disabled" :auto-select-first="autoSelectFirst" v-on:input="onInput" :rules="rules" :items="data.items" :loading="data.isLoading" :search-input.sync="data.search" item-text="code" item-value="_id" no-data :no-data-text="'- type to find -'" clearable @focus="onFocus" @change="onInput" :no-filter="true" return-object :required="required" :hint="hint" :persistent-hint="hint ? true : false" flat hide-details></v-autocomplete>
  </span>
</template>

<script lang="ts">
import {Component, Prop, Vue, Watch} from "vue-property-decorator"
import {debounce} from "./../../../libs/debounce"
import eventBus from "../../../eventBus"
import {cantonService} from "./service"
import {rules} from "./../../../libs/utils"

@Component({
  components: {},
})
export default class CantonSelect extends Vue {
  @Prop({default: () => []})
  rules

  @Prop({default: false})
  autoSelectFirst

  @Prop({default: false})
  allowNew

  @Prop()
  value

  @Prop()
  required

  @Prop()
  disabled

  @Prop({default: "Canton"})
  label

  @Prop({default: null})
  hint

  @Prop()
  siteID

  data: any = {
    items: [],
    isLoading: false,
    search: null,
    blockSearch: true,
  }

  async created() {
    // await this.loadItems()
    console.log("this.value for CANTON", this.value)
    if (this.value) {
      Vue.set(this.data, "items", [this.value])
    }
    setTimeout(() => {
      this.data.blockSearch = false
    }, 1000)
  }

  onInput(val) {
    this.$emit("input", val)
  }

  async onFocus() {
    this.loadItems()
  }

  @Watch("value")
  onValueSet(val) {}

  @Watch("data.search")
  find(val) {
    if(this.data.blockSearch) {
      return
    }
    console.log("findvalue a", this.data.search)
    debounce.delay(() => {
      this.loadItems()
    }, 450)
  }

  async loadItems() {
    console.log("loading items for CANTON")
    if (this.data.isLoading) {
      return
    }
    this.data.isLoading = true
    let payload = {
      q: this.data.search,
    }
    try {
      let options = {fields: "code", limit: 100}
      let res = await cantonService.find(payload, options)
      if (res.error == true || res.data == null) {
        eventBus.$emit("display-snackbar", {type: "error", text: "Failed to load items. Please check your internet connection and try again"})
        this.data.isLoading = false
        return
      }

      this.data.items = res.data.sort((a, b) => {
        return a.code.localeCompare(b.code)
      })
      this.data.isLoading = false
    } catch (error) {
      console.log(error)
      this.data.isLoading = false
    }
  }
}
</script>
